/**
 * Карточка диалога — колонка флекса (`.modal` в base.css) с потолком `max-height: 100%` и
 * собственной прокруткой. Прокручиваться обязана КАРТОЧКА, а не сжиматься её содержимое.
 *
 * ПОЧЕМУ `flex-shrink: 0` НА КАЖДОМ РЕБЁНКЕ. У флекс-элемента `min-height: auto` не даёт ему
 * сжаться ниже содержимого — но только пока он сам не контейнер прокрутки. `.tblwrap`
 * (`overflow-x: auto; overflow-y: hidden`) — контейнер, и его автоматический минимум равен
 * нулю; SVG графика сжимается по пропорции. Как только содержимое выше окна, флекс отбирает
 * высоту именно у них: таблица сплющивается и режет строки своим `overflow-y: hidden`, график
 * съёживается в полоску, а у карточки не остаётся переполнения, то есть и прокрутки. Окно
 * метрики на «Мониторинге» (таблица и график — прямые дети карточки) так и не листалось:
 * при «всё время» на 60 неделях из 61 строки было достижимо двенадцать (15.10.2026).
 */
.card > * {
  flex-shrink: 0;
}
